<template v-if="globaljs.mb_staff !== 'Worker'">
	<include-header />

	<section id="modal_user_add">
		<div class="modal_box">
			<div class="modal_tit">계정생성</div>
			<div class="modal_close"></div>
			<div class="modal_inner">
				<form ref="form_staff_register" id="form_staff_register" :action="`${SERVER_URL}/api/app/member/staff`"
					@submit.prevent="form_staff_register_submit()" method="post" enctype="multipart/form-data"
					autocomplete="off">
				<!-- <form id="infoForm" name="frmMember" class="infoForm" method="post" action="user_update.php" onsubmit="return form_staff_register_submit(this);"> -->
					<div id="infoForm" class="infoForm">
						<table>
							<tbody>
								<tr>
									<td class="memberCols1"><label for="reg_mb_id">아이디<span class="essential"></span></label></td>
									<td class="memberCols2">
										<input type="text" v-model="form.mb_id" id="reg_mb_id" class="wcalc id" placeholder="아이디" required="" @keyup.enter.prevent="id_check_submit()" minlength="6" maxlength="20" autocomplete="off">
										<input type="button" id="id_check" @click="id_check_submit()" @keyup.enter.prevent="id_check_submit()" class="join_form_btn" value="중복확인">
										<div class="required_info">* 아이디는 6~20자 영문 또는 숫자</div>
									</td>
								</tr>
								<tr>
									<td class="memberCols1"><label for="reg_mb_password">비밀번호<span class="essential"></span></label></td>
									<td class="memberCols2">
										<input type="password" v-model="form.mb_password" id="reg_mb_password" class="w100" placeholder="비밀번호" required="" minlength="8" maxlength="16" autocomplete="new-password">
										<div class="required_info">* 비밀번호는 8~16자 <span class="text-orange">영문, 숫자, 특수문자 필수</span></div>
									</td>
								</tr>
								<tr>
									<td class="memberCols1"><label for="reg_mb_password_re">비밀번호 확인<span class="essential"></span></label></td>
									<td class="memberCols2">
										<input type="password" v-model="form.mb_password_re" id="reg_mb_password_re" class="w100" placeholder="비밀번호 확인" required="" minlength="8" maxlength="16" autocomplete="new-password">
									</td>
								</tr>
								<tr>
									<td class="memberCols1"><label for="reg_mb_name">성명<span class="essential"></span></label></td>
									<td class="memberCols2">
										<input type="text" v-model="form.mb_name" id="reg_mb_name" class="w100" placeholder="성명" required="">
									</td>
								</tr>
							</tbody>
						</table>
						<button type="button" class="btn_style1 userAddBtn" style="display:block;" @click="form_staff_register_submit()">생성</button>
					</div>
				</form>
			</div>
		</div>
	</section>

	<section id="modal_pw_edit">
		<div class="modal_box">
			<div class="modal_tit">비밀번호 변경</div>
			<div class="modal_close"></div>
			<div class="modal_inner">

				<form ref="form_staff_pw" id="form_staff_pw" :action="`${SERVER_URL}/api/app/member/staff`"
						@submit.prevent="form_staff_pw_submit()" method="post" enctype="multipart/form-data"
						autocomplete="off">
				<!-- <form id="pwEditForm" name="frmPwEdit" method="post" action="user_pw_change.php" onsubmit="return form_staff_pw_submit()"> -->
					<!-- <input type="hidden" name="mb_id" value=""> -->
					<table>
						<tbody>
							<tr>
								<td class="pwEditCols1"><label for="reg_mb_password">비밀번호<span class="essential"></span></label></td>
								<td class="pwEditCols2">
									<input type="password" v-model="form.new_password" id="reg_new_password" class="w100" placeholder="비밀번호" required="" minlength="8" maxlength="16" autocomplete="new-password">
									<div class="required_info">* 비밀번호는 8~16자 <span class="text-orange">영문, 숫자, 특수문자 필수</span></div>
								</td>
							</tr>
							<tr>
								<td class="pwEditCols1"><label for="reg_mb_password_re">비밀번호 확인<span class="essential"></span></label></td>
								<td class="pwEditCols2">
									<input type="password" v-model="form.new_password_re" id="reg_new_password_re" class="w100" placeholder="비밀번호 확인" required="" minlength="8" maxlength="16" autocomplete="new-password">
								</td>
							</tr>
						</tbody>
					</table>
					<button type="button" class="btn_style1 savePwBtn" @click="form_staff_pw_submit">완료</button>
				</form>
			</div>
		</div>
	</section>

	<div class="modal_bg"></div>

	<section id="lab_manage_user">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">직원 목록</div>
					<div class="searchBox">
						<form ref="form_search" id="form_search" @submit.prevent="getModels()">
							<div class="searchRow">
								<div class="searchCont">
									<label for="staffNameSearch" class="form-label required">이름</label>
									<input type="text" class="form-control" v-model="searchModels.other_name" id="staffNameSearch" placeholder="이름">
								</div>
								<div class="searchCont">
									<label for="staffIdSearch" class="form-label required">ID</label>
									<input type="text" class="form-control" v-model="searchModels.other_id" id="staffIdSearch" placeholder="ID">
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn" @click.prevent="getModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
								</div>
							</div>
						</form>
					</div>
					<div class="sub_contBox">
						<form ref="form_staff_list" id="form_staff_list" :action="`${SERVER_URL}/api/app/member/staff`"
							@submit.prevent="form_staff_delete_submit()" method="post" autocomplete="off">
							<input type="hidden" name="checked_id">

							<div class="subTitWrap">
								<div class="subTit">[직원 목록]</div>
								<ul class="subBtn">
									<li><button type="button" class="regist_btn" id="uRegistBtn">계정생성</button></li>
									<li><button type="button" class="delete_btn" id="uDeleteBtn" @click="form_staff_delete_submit()">삭제</button></li>
								</ul>
							</div>
							<div class="authorityTxt">
								<p>*</p><p>관리자 : 대시보드, 주문관리, 정산관리, 환경설정<br>작업자 : 대시보드, 주문관리</p>
							</div>

							<table>
								<thead>
									<tr>
										<th class="chkBox"><input type="checkbox" @click="checkAll($event)" id="chk_all"></th>
										<th class="cols2">이름</th>
										<th class="cols3">아이디</th>
										<th class="cols4">생성일시</th>
										<th class="cols5">접근권한<span>*</span></th>
										<th class="cols6">비밀번호 변경</th>
									</tr>
								</thead>
								<tbody :class="HZwrapper">
									<tr v-if="paginatedItems.length > 0" v-for="(item, index) in paginatedItems" :key="item.id" class="tableItem">
										<td class="cols_chk">
											<input type="checkbox" :name="'chk[]'" class="chk" :value="item.id">
											<!-- // @change="handleCheckboxChange(item.id) -->
										</td>
										<td class="cols2">{{ item.mb_name }}</td>
										<td class="cols3">{{ item.mb_id }}</td>
										<td class="cols4">{{ commonjs.dateFormatYMD(item.mb_join_date) }}</td>
										<td class="cols5">
											<select name="mb_2" class="levelSelect" :value="item.mb_staff" @change="handleStaffChange($event, item.mb_id, item.mb_staff)">
												<option value="Worker">작업자</option>
												<option value="Manager">관리자</option>
											</select>
										</td>
										<td class="cols6"><div class="passwordBtn" @click="select_pw(item.mb_id)">변경</div></td>
									</tr>
									<tr v-else>
										<td colspan="6">데이터가 없습니다.</td>
									</tr>
								</tbody>
							</table>

							<div class="page">
								<ul :id="HZpaginationId" class="pagination">
									<li :class="HZpaginationArrowsClass" v-show="currentPage > 1" @click="previousPage">&lt;</li>
									<li>
										<ul class="num_wrap">
											<li v-for="page in pagesToShow" :key="page" :class="['paginacaoValor', HZpaginationCustomClass, { 'active': currentPage === page }, 'num']" @click="goToPage(page)">
												{{ page }}
											</li>
										</ul>
									</li>
									<li :class="HZpaginationArrowsClass" v-show="currentPage < totalPages" @click="nextPage">&gt;</li>
								</ul>
							</div>

						</form>
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as registerjs from '@/components/utils/register';
import { staff_rank_update } from '@/components/utils/common_func_axios';

const route = useRoute();
const router = useRouter();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

let form_search = ref(null)
let searchModels = ref({})

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') { 
		await getModels();
	}
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = '';
		selectElement.selected = true;
	});

	await getModels();
}

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	return Object.values(searchModels.value).some(value => value !== '');
});

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';
const HZperPage = 10;
const HZpaginationId = 'pagination-container';
const HZpaginationArrowsClass = 'paginacaoCursor';
const HZpaginationCustomClass = 'customPagination';
const currentPage = ref(1);
const totalPages = computed(() => Math.ceil(items.value.length / HZperPage));

const paginatedItems = computed(() => {
	const start = (currentPage.value - 1) * HZperPage;
	const end = start + HZperPage;
	return items.value.slice(start, end);
});

const goToPage = (page) => {
	if (page > 0 && page <= totalPages.value) {
		currentPage.value = page;
	}
};

const previousPage = () => {
	if (currentPage.value > 1) {
		currentPage.value--;
	}
};

const nextPage = () => {
	if (currentPage.value < totalPages.value) {
		currentPage.value++;
	}
};

const pagesToShow = computed(() => {
	const pages = [];
	const totalPagesValue = totalPages.value;
	const currentPageValue = currentPage.value;
	const showPagesCount = 10; // 한번에 보여줄 페이지 번호 개수
	const halfShowPagesCount = Math.floor(showPagesCount / 2);

	let start = Math.max(1, currentPageValue - halfShowPagesCount);
	let end = Math.min(totalPagesValue, currentPageValue + halfShowPagesCount);

	if (currentPageValue <= halfShowPagesCount) {
		end = Math.min(totalPagesValue, showPagesCount);
	}

	if (currentPageValue > totalPagesValue - halfShowPagesCount) {
		start = Math.max(1, totalPagesValue - showPagesCount + 1);
	}

	for (let i = start; i <= end; i++) {
		pages.push(i);
	}

	return pages;
});

const checkAll = (event) => {
	const checkboxes = document.querySelectorAll('.chk');
	checkboxes.forEach(checkbox => {
		checkbox.checked = event.target.checked;
	});
};

// 각 체크박스의 상태를 변경할 때마다 이 함수가 호출되도록 설정
function updateCheckedIds() {
	const checked_id_input = document.querySelector('input[name="checked_id"]');
	const formElement = document.getElementById('form_staff_list');
	
	// 체크된 체크박스의 값을 담을 배열
	const checkedValues = [];

	// 체크된 체크박스의 값을 배열에 추가
	formElement.querySelectorAll('input[type="checkbox"]').forEach((input) => {
		if (input.type === 'checkbox' && input.id !== 'chk_all' && input.checked) {
			checkedValues.push(input.value);
		}
	});

	// checked_id_input의 값을 새로 갱신
	checked_id_input.value = checkedValues.join(',');
}

async function staffChange(event, mb_id, before) {
	let newRank = event.target.value; // 새로 선택된 상태 값

	var prev_value = new Array();
	prev_value[mb_id] = newRank;

	const is_confirm = await commonjs.confirmSwal('직원권한변경 확인', '해당 직원의 권한을 변경하시겠습니까?');
	if (!is_confirm) {
		event.target.value = before;
		return false;
	}

	const data = {
		mb_boss_id: globaljs.mb_boss_id,
		mb_id: mb_id,
		mb_staff: newRank
	};

	const result = await staff_rank_update(data);

	if (result.result === 'success') {
		prev_value[mb_id] = newRank;

		toast.fire({
			icon: "success",
			title: result.msg,
		});
		return true;

	} else {
		event.target.value = before;

		toast.fire({
			icon: "error",
			title: result.msg,
		});
		return false;
	}
}

// 상태 변경 처리
const handleStaffChange = async (event, mb_id, mb_staff) => {
	try {
		const before = mb_staff;
		const after = event.target.value;

		if( before !== after ) {
			const isSuccess = await staffChange(event, mb_id, before);

			if (isSuccess) {
			} else {
				event.target.value = before;
			}
		}
	} catch (error) {
		console.error('Error changing status:', error);
	}
};

const select_pw = (mb_id) => {
	form.value.pw_id = mb_id;
	form.value.new_password = '';
	form.value.new_password_re = '';

	document.documentElement.style.overflow = 'hidden';
	document.body.style.overflow = 'hidden';
	document.querySelector('#modal_pw_edit').style.display = 'block';
	document.querySelector('.modal_bg').style.display = 'block';
}

const form = ref({
	mb_id: '',
	mb_password: '',
	mb_password_re: '',
	mb_name: '',
	id_check: 0,
	new_password: '',
	new_password_re: '',
	pw_id: '',
});

// 240820 아이디 입력값과 중복체크한 아이디랑 달라지면 다시 중복체크해야됨.
watch(
	() => form.value.mb_id,
	(newVal) => {
		if (newVal === form.value.checked_mb_id) {
			form.value.id_check = 1;
		} else {
			form.value.id_check = 0;
		}
	}
);

document.addEventListener('click', async function (e) {
	if (e.target && e.target.id === 'id_check') {
		
	}
});

const id_check_submit = async () => {
	var result = await registerjs.id_check(document.getElementById("reg_mb_id").value);
console.log(result);

	if (result === 'able') {
		form.value.id_check = 1;
		Swal.fire({
			title: '사용 가능',
			text: '[' + document.getElementById('reg_mb_id').value + '] 사용가능한 아이디입니다',
			icon: 'success',
			confirmButtonText: '확인',
			allowOutsideClick: false,  // 외부 클릭 방지
			allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: false,
		}).then((result) => {
			if (result.isConfirmed) {
				setTimeout(function () {
					document.getElementById('reg_mb_password').focus();
				}, 100);
			}
		});
	} else {
		form.value.id_check = 0;
		var txt = '';
		var tit = '';
		if (result === 'exist') {
			tit = '사용 불가';
			txt = '이미 사용중인 아이디입니다';
		} else {
			tit = '아이디 입력 오류';
			txt = result;
		}

		Swal.fire({
			title: tit,
			text: txt,
			icon: 'error',
			confirmButtonText: '확인',
			// allowOutsideClick: false,  // 외부 클릭 방지
			// allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
			returnFocus: true,
		});
	}
}

const items = ref([]);

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	params.append('mb_id', globaljs.mb_id);

	params.append('orderBy', 'mb_join_date'); // 정렬필드
	params.append('align', 'desc'); // 정렬순서

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/member/staff`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}

async function form_staff_register_submit() {
	await withSubmitFlag(async () => {
		if (form.value.id_check === 0) {
			commonjs.formSwal('아이디', '아이디', '#reg_mb_id', 'exist');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.mb_password)) {
			commonjs.formSwal('비밀번호', '비밀번호', '#reg_mb_password', 'type');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.mb_password_re)) {
			commonjs.formSwal('비밀번호 확인', '비밀번호', '#reg_mb_password_re', 'type');
			return false;
		}
		if (form.value.mb_password != form.value.mb_password_re) {
			commonjs.formSwal('비밀번호 입력 오류', '비밀번호가 서로 다릅니다.', '#reg_mb_password', 'self');
			return false;
		}
		if (!form.value.mb_name || form.value.mb_name.length < 1) {
			commonjs.formSwal('성명', '성명', '#reg_mb_name');
			return false;
		}

		const params = new URLSearchParams();
		params.append('mb_boss_id', globaljs.mb_boss_id);
		params.append('acc_type', globaljs.acc_type);
		params.append('mb_staff', 'Worker'); // 직원 디폴트:작업자
		params.append('mb_id', form.value.mb_id);
		params.append('mb_password', form.value.mb_password);
		params.append('mb_password_re', form.value.mb_password_re);
		params.append('mb_name', form.value.mb_name);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/member/staff`, params);
	console.debug(response.data.result);
			document.querySelector('.modal_close').click();

			toast.fire({
				icon: "success",
				title: `[${form.value.mb_id}] 계정을 생성했습니다.`
			});

			form.value.mb_id = '';
			form.value.mb_password = '';
			form.value.mb_password_re = '';
			form.value.mb_name = '';
			form.value.id_check = 0;

			getModels();
			// router.push("/register_complete");
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}

async function form_staff_pw_submit() {
	await withSubmitFlag(async () => {
		if (!form.value.pw_id || form.value.pw_id.length < 1) {
			commonjs.formSwal('아이디', '아이디 선택', '.passwordBtn');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.new_password)) {
			commonjs.formSwal('비밀번호', '비밀번호', '#reg_new_password', 'type');
			return false;
		}
		if (!registerjs.pwdRule.test(form.value.new_password_re)) {
			commonjs.formSwal('비밀번호 확인', '비밀번호', '#reg_new_password_re', 'type');
			return false;
		}
		if (form.value.new_password != form.value.new_password_re) {
			commonjs.formSwal('비밀번호 입력 오류', '비밀번호가 서로 다릅니다.', '#reg_new_password', 'self');
			return false;
		}

		const params = new URLSearchParams();
		params.append('mb_boss_id', globaljs.mb_boss_id);
		params.append('pw_id', form.value.pw_id);
		params.append('new_password', form.value.new_password);
		params.append('new_password_re', form.value.new_password_re);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.patch(`${SERVER_URL}/api/app/member/staff`, params);
	console.debug(response.data.result);

			document.querySelector('.modal_close').click();

			toast.fire({
				icon: "success",
				title: `[${form.value.pw_id}] 계정의 비밀번호를 변경했습니다.`
			});

			form.value.pw_id = '';
			form.value.new_password = '';
			form.value.new_password_re = '';

			getModels();
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}

async function form_staff_delete_submit() {
	await withSubmitFlag(async () => {
		const enabledInputs = document.querySelectorAll("input[type='checkbox'].chk:checked");
		// enabledInputs의 길이를 카운팅합니다.
		const count = enabledInputs.length;
		if (count < 1) {
			commonjs.formSwal('필수 선택', '삭제 할 항목을 하나 이상 선택해주세요.', '#chk_all', 'self');
			return false;
		}

		const formElement = document.getElementById('form_staff_list');
		const essentials = formElement.querySelectorAll('[required]');
		for (const element of essentials) {
			if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
				return false;
			}

			// input type="date"의 경우 날짜 형식 검증
			if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
				return false;
			}
		}

		// 폼 제출 시 업데이트된 checked_id_input의 값을 사용하도록 호출
		updateCheckedIds();

		const is_confirm = await commonjs.confirmSwal('직원 삭제 확인', `선택한 ${count}개의 계정을 삭제 하시겠습니까?`);
		if (!is_confirm) {
			return false;
		}

		const checked_id_input = document.querySelector('input[name="checked_id"]');

		const params = new URLSearchParams();
		params.append('mb_boss_id', globaljs.mb_boss_id);
		params.append('checked_id', checked_id_input.value);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.delete(`${SERVER_URL}/api/app/member/staff`, { params });
	console.debug(response.data.result);
			document.querySelector('.modal_close').click();

			toast.fire({
				icon: "success",
				title: `선택한 ${count}개의 계정을 삭제했습니다.`
			});

			getModels();
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>